import { setAppError, setPathingAppState } from "../../actions/App/dispatchers";
import { fetch_detail } from "../../actions/Detail/dispatchers";
import { reset_right_rail } from "../../reducers/RightRail/reducer";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";
import {
    metaPreviewReplacer,
    metaNinePreviewReplacer,
    previewType,
} from "../../utils/page/library";

export const fetchDetailNoAdsPageData = (path, params) => async (dispatch) => {
    const { contentId } = params;
    const preview = previewType(path);
    let newPath;
    if (!preview) {
        newPath = path;
    } else {
        newPath =
            preview === "nine"
                ? metaNinePreviewReplacer(path)
                : metaPreviewReplacer(path);
    }

    dispatch(reset_app_state(newPath, contentId));
    dispatch(reset_right_rail());

    try {
        await dispatch(fetch_detail(contentId, preview));
        dispatch(setPathingAppState(newPath, false, contentId));
    } catch (error) {
        dispatch(setAppError(newPath, error.code));
    }
};
